<template>
  <div class="task-reassign-form" :class="modalTheme" >
    <div class="d-flex flex-column">
      <h4 hidden class="text-center pb-2 position-sticky">Patient Tasks ReAssign FORM</h4>

      <div hidden style="background-color: darkgrey; color: green">
        <h4>statusData</h4>
        <h6 style="background-color: black; color: cyan">statusComments {{ statusData.statusComments.length }}</h6>
        <h6 style="background-color: black; color: red">statusOptions {{ statusData.statusOptions.length }}</h6>
        <h6 style="background-color: black; color: orange">status :{{ statusData.status }}</h6>
        <h6 style="background-color: black; color: lime">status :{{ statusData.status }}</h6>
      </div>

      <div hidden style="background-color: black; color: orange">
        <h5 style="background-color: darkred; color: magenta">form.statusSelection {{ form.statusSelection }}</h5>
        <h6 style="background-color: darkblue; color: cyan">form.statusOPT {{ form.statusOptions }}</h6>

        <h6 style="background-color: darkblue; color: red">statusOptions {{ statusData.statusOptions.length }}</h6>
        <h6 style="background-color: darkblue; color: orange">status selection: {{ statusData.status }}</h6>

        <h6 :click="bindStatus" style="color: lime">incomingStatus: {{ incomingStatus }}</h6>
      </div>

      <!-- statusData.statusComments: {{statusData.statusComments.length}}
			statusCommentsArray: {{statusCommentsArray.length}}-->

      <div class="patient-reassign">
        <div class="d-flex flex-column">
          <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
            <b-form-group id="selectRecipientsGroup" label="Select Recipients: (type names, groups to lookup)" label-for="selectRecipientsInput">
              <Multiselect
                v-model="form.recipients[0]"
                :multiple="false"
                :close-on-select="true"
                :hide-selected="false"
                :options="messageTypeUsers"
                placeholder="Select..."
                label="name"
                track-by="name"
              ></Multiselect>

              <pre hidden class="language-json"><code style="color:cyan;">{{ form.recipients  }}</code></pre>

              <div>
                <br />
                <label>Comment:</label>
                <b-form-textarea id="reassignComment" v-model="form.currentComment" placeholder="Enter a Comment for the ReAssign change" rows="3" max-rows="6" required> </b-form-textarea>
                <br />
                <div class="btnsContainer ml-6">
                  <b-row>
                    <!-- <b-col></b-col> -->
                    <b-col>
                      <b-button :class="modalTheme" type="reset" variant="primary-green">Reset</b-button>
                    </b-col>
                    <b-col>
                      <b-button :class="modalTheme" type="submit" variant="primary-green">Submit</b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <div>
                <status-comment class="comment-box" v-for="sComment in form.statusComments" :comment="sComment" :key="sComment.commentId" />
              </div>
            </b-form-group>
          </b-form>

          <b-card hidden class="mt-3" bg-variant="dark" text-variant="white" header="Form Data Result">
            <pre hidden variant="warning" class="m-0">{{ form }}</pre>
          </b-card>
        </div>
        <!-- <div class="d-flex mt-3">
						<div class="ml-auto patient-note-buttons">
							<b-button class="mr-3" type="submit" variant="primary">Submit</b-button>
							<b-button type="reset" variant="danger">Cancel</b-button>
						</div>
				</div>-->
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { toast } from "vue3-toastify";

// * STORE
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import Multiselect from "vue-multiselect";

// & PROPS
const props = defineProps({
  statusData: {
    Type: Object,
    Default: () => {},
  },
});
// * a computed ref
const messageTypeUsers = computed(() => {
// console.log(userStore.userLists);
// console.log(userStore.users);
  return [...userStore.userLists, ...userStore.users];
});
// console.log("messageTypeUsers");
// console.log(messageTypeUsers);

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(true);

const form = ref({
  recipients: [],
});

// * EMITTER
const emit = defineEmits(["postTaskReAssign", "close-modal"]);

function onSubmit() {
// console.log("     PATIENT TASK    RE ASSIGN FORM  >  onSubmit");

// console.log("TODO 		this.form.rowId = this.statusData.id");

// console.log("props.statusData.id");
// console.log(props.statusData.id);
// console.log();
// console.log();
// console.log();

  form.value.rowId = props.statusData.id;
// console.log(" form.rowId");
// console.dir(form.value.rowId);

// console.log(" REcipients");
// console.dir(form.value.recipients);

// console.log("");
  if (form.value.recipients.length < 1) {
    toast.error("Please select recipient(s)");
    return;
  }
  // if (this.currentComment.length >= 4000) {
  // 	toast.error('The maximum size of the note is 4000 characters')
  // 	return
  // }
  // if (this.currentComment.length < 5) {
  // 	toast.error('A comment should be at least 5 characters')
  // 	return
  // }
  // this.statusComments.push(this.currentComment)

// console.log(" ^^^^^^^  FORM SUBMITTAL ^^^^^^^^^^^^^");
  // console.log(' 				form.value.recipients ', this.form.value.recipients)

  // const payload = {
  //   ...form,
  //   recipients: form.value.recipients.map((recipient) => recipient.id),
  // };

  // console.log('			......................RECHECK payload')
  // console.dir(payload);

  // form.statusSelection

// console.log("			PatientTask REASSIGN FORM >> EMITTING from onSubmit ");
// console.log("							EMITTER :  post-TaskReAssign");
  // console.log('		ID: ', form.rowId)
  // console.log('		recipients: ', form.recipients)
  // console.log('		currentComment: ', form.currentComment)

  //   this.$emit("postTaskReAssign", {
  //     id: this.form.rowId,
  //     recipients: this.form.recipients[0].id,
  //     text: this.form.currentComment,
  //   });

  emit("postTaskReAssign", {
    id: form.value.rowId,
    recipients: form.value.recipients[0].id,
    text: form.value.currentComment,
  });

  onReset();
}
function onReset() {
  form.value.recipients = [];
  form.value.currentComment = "";
  // form.value.statusSelection = this.statusData.status;
  modalShow.value != modalShow.value;
  // this.$emit("close-modal");
  emit("close-modal");
}

onMounted(() => {
// console.log("onMounted() :      PATIENT TASK  REASSIGN  FORM  >>>>");
// console.log("  >> Backup AND TRACE import Multiselect from vue-multiselect");
// console.log("props : ");
// console.log(props);
// console.log(" prop   statusData ");
// console.log(props.statusData);

// console.log('DESIGN computedVal  messageTypeUsers >> :options="messageTypeUsers"  for <MuLtiS> : ');
// console.log("messageTypeUsers");
// console.log(messageTypeUsers);
});
</script>

<!-- * MultiSelect CSS -->
<!-- <style src="../../node_modules/vue-multiselect/dist/vue-multiselect.css"></style> -->

<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style lang="scss" scoped>
.task-reassign-form {
  text-align: initial; // need this because the dx-toolbar text-align: center was causing problems with the labels
  //  background-color: #849185;
  //@debug  color: #ebebeb;
  padding-left: 15px;
  padding-top: 15px;
  padding-right: 15px;
  padding-bottom: 0px;
}

.comments-list {
  list-style: none;
  .comment {
    padding: 0.5rem 0;
    word-wrap: break-word;
    white-space: pre-wrap; // this is so we don't have to use pre
  }
  .comment-text {
    font: inherit;
    font-size: 0.75em;
  }
  .comment-date {
    font-size: 0.75em;
    font-weight: 800;
    padding-bottom: 0.5rem;
    color: #123486;
  }
}

.existing-comment {
  //  background: #f8f8f8;
  margin: 2rem;
  padding: 1rem;
  border-radius: 1rem;
  width: 100%;
  overflow-y: auto;
  max-height: 50vh;
}
.patient-comment {
  padding-top: 1rem;
  width: 100%;
  margin: 0 auto;
  &-textarea {
    display: block;
    height: 6rem;
    // margin: 0 auto;
    // width: 80%;
  }
  .task-form {
    margin-top: 1rem;
    height: 8rem;
  }
}
.btnsContainer {
  display: flex;
  justify-content: flex-end;
}
.btn-primary-green {
  border: none;
  text-decoration: none;
  color: #fcfefc;
  background-color: #b0c1b2;
  padding-left: 10px;
  padding-right: 10px;
}
.btn-primary-green:hover {
  background-color: #caeacd;
  color: #123486;
  border-radius: 0px 0px 0px 0px;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
  background: #eef8ef;
}
</style>
